export function initNavbar() {

  const navbarMain = document.getElementsByClassName('inst-navbar-main')[0];
  if (navbarMain) {
    window.onscroll = function () {
      if (window.scrollY >= 100) {
        navbarMain.classList.add('opaque');
      } else {
        navbarMain.classList.remove('opaque');
      }
    }
  }

}